<template>
  <div class="home contenido">
    <div class="container">
    <HeaderSeguros 
        msg="Profesionales independientes y Pymes"
        idea="Estamos preparados para darle estabilidad, respuesta y acompañamiento a tu proyecto, pues sabemos que su crecimiento depende de ti."
        clase="profesionales-independientes-y-pymes"
     />
     <Titulo titulo="Planes para que estés un paso adelante" />
     <FotoTexto titulo="Autos" texto="Lo más importante es que tu negocio no se detenga; te ayudamos a administrar la operación de flotillas desde 4 hasta 200 vehículos de acuerdo a tus necesidades." linkURL="#tresPasos" textoURL="Asegura tu auto o tu flotilla" :imagen="imagen2" pos="fotoderecha"></FotoTexto>
     <FotoTexto titulo="Salud" texto="Protección y servicios integrales para ti y para tus empleados. Un seguro de gastos médicos mayores te da ventajas competitivas y contribuye al
     crecimiento de tu proyecto." linkURL="#tresPasos" textoURL="Contrata un seguro de gastos médicos" :imagen="imagen3" pos="fotoizquierda"></FotoTexto>
     <FotoTexto titulo="Vida" texto="Seguro de vida para los empleados.  Contribuye a la tranquilidad de tus colaboradores respaldándolos ante situaciones delicadas que se pueden
     presentar en la vida." linkURL="#tresPasos" textoURL="Contrata seguros de vida ahora" :imagen="imagen4" pos="fotoderecha"></FotoTexto>
     <FotoTexto titulo="Daño al negocio" texto="La operación del negocio es el eje de todo.  Prepárate para su continuidad con distintas coberturas que te dan soporte ante lo inesperado, daños materiales a inmueble, contenidos, sismo, robo, responsabilidad civil y más." linkURL="#tresPasos" textoURL="Asegura tu negocio de daños ahora" :imagen="imagen5" pos="fotoizquierda"></FotoTexto>
  </div>
  <Trespasoscompleto />
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderSeguros from '@/components/HeaderSeguros.vue'
import Imagen from '@/assets/images/banner-header_02-profesionales-independientes-y-pymes.png'
import Titulo from '@/components/Titulo.vue'
import FotoTexto from '@/components/FotoTexto.vue'
import Imagen2 from '@/assets/images/pageinteriors_profesionales-independientes-y-pymes-01autos.jpg'
import Imagen3 from '@/assets/images/pageinteriors_profesionales-independientes-y-pymes-02salud.jpg'
import Imagen4 from '@/assets/images/pageinteriors_profesionales-independientes-y-pymes-03vida.jpg'
import Imagen5 from '@/assets/images/pageinteriors_profesionales-independientes-y-pymes-04dano.jpg'
import Trespasoscompleto from '@/components/Trespasoscompleto.vue'
export default {
  name: 'Profesionales-independientes-y-pymes',
  data() {
      return {
          imagen: Imagen,
          imagen2: Imagen2,
          imagen3: Imagen3,
          imagen4: Imagen4,
          imagen5: Imagen5,
      }
  },
  components: {
    HeaderSeguros,
    Titulo,
    FotoTexto,
    Trespasoscompleto,
  },
  methods: {
      cambiaImagen: function(imagen){
          this.$store.commit('cambiaImagen', imagen);
      },
      muestraFooter: function(){
          this.$store.commit('muestraFooter');
      }
  },
  mounted: function(){
      console.log(Imagen);
      this.cambiaImagen(Imagen);
      this.muestraFooter();
      this.$store.commit('mideMenos', false);
      this.$store.commit('mideMas', false);
      this.$store.commit('estira', false);
  }
}
</script>
<style scoped>
.contenido {
    min-height: 500px;
}
@media only screen and (max-width: 1199px){
}
</style>
